import TemplateLabourCostOnsiteApi from './TemplateLabourCostOnsiteApi';

export default TemplateLabourCostOnsiteApi;
